module.exports = __webpack_public_path__ + "static/template_options_gantt_chart-4b93c70936d8ecd13a6e8897019cfffb.png";